import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InspectionType } from '../../_objects/InspectionType';
import { InspectionTypeContractService } from '../interfaces/inspection-type-contract.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionTypeOfflineService implements InspectionTypeContractService {

  constructor() { }

  getInspectionTypes(): Observable<InspectionType> {
    throw new Error('Method not implemented.');
  }
  
}
